import styled from '@emotion/styled';
import { defaultContainerSize, mq } from '../../../styles/mixins';
import { css } from '@emotion/react';
import { Headline1, ParagraphS } from '../../core/Typography/Typography';

type ImageWrapperType = {
  isImageToRight?: boolean;
};

export const Section = styled.section`
  position: relative;
  ${mq.medium(css`
    flex-direction: row;
    justify-content: space-between;
  `)}
`;

export const Container = styled.div`
  ${defaultContainerSize};
  display: flex;
  flex-direction: column;
  gap: 4rem;
  justify-content: space-between;
  padding-top: 2rem;
  padding-bottom: 0;

  ${mq.large(css`
    ${defaultContainerSize};
    flex-direction: row;
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  `)}
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Title = styled.h1`
  ${Headline1};
  max-width: 21.4375rem;
  text-align: left;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0;

  ${mq.medium(css`
    max-width: 29.1875rem;
  `)}

  ${mq.xLarge(css`
    max-width: 33.5rem;
    line-height: 3.5rem;
    letter-spacing: -0.0125rem;
  `)}
`;

export const Subtitle = styled.h2`
  ${Headline1};
  margin: 0;
  text-align: left;
  color: ${({ theme }) => theme.colors.black};
`;

export const Description = styled.p`
  ${ParagraphS};
  letter-spacing: 0.0125rem;
  color: ${({ theme }) => theme.colors.core_black};
  margin: 2rem 0 0 0;

  ${mq.large(css`
    max-width: 29.1875rem;
  `)}

  ${mq.xLarge(css`
    max-width: 36rem;
  `)}
`;

export const Image = styled.div<ImageWrapperType>`
  position: relative;
  width: 100%;
  height: auto;
  min-height: 20.375rem;
  max-width: 23rem;
  align-self: flex-end;

  ${({ isImageToRight }) =>
    isImageToRight &&
    css`
      ${mq.large(css`
        position: absolute;
      `)}
      right: 0;
      bottom: 0;
    `}

  ${mq.large(css`
    max-width: 26.625rem;
    height: 100%;
    position: absolute;
    right: 0;
    bottom: 0;
  `)}

  ${mq.xLarge(css`
    max-width: 31.25rem;
    height: 100%;
    align-items: flex-end;
  `)}
  
  img {
    width: 100%;
    height: 100%;
    max-height: 27.563rem;
    inset: inherit;
  }
`;
